import { ShopCart } from '../redux/types'

export const shopCartItemsEqual = (item1: ShopCart, item2: ShopCart) =>
    item1.stripeId === item2.stripeId
